import useSWR from "swr";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { fetchFruits } from "../lib/api";
import PageHeader from "../components/PageHeader";
import FruitCard from "../components/FruitCard";
import { Reveal, StaggerGroup } from "../components/Reveal";

export default function Products() {
  const { data: fruits } = useSWR("fruits", fetchFruits);

  return (
    <>
      <PageHeader
        overline="What we carry"
        lines={["Thirteen families.", "One commission desk."]}
        intro="Every family below is sourced from both Indian orchards and international growers, so the calendar rarely runs empty. Tap any family to open its month-by-month sourcing manifest."
      />

      <section className="mx-auto max-w-[1400px] px-5 py-16 md:px-10 md:py-24">
        <StaggerGroup className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {(fruits || []).map((f, i) => (
            <FruitCard key={f.slug} fruit={f} index={i} />
          ))}
        </StaggerGroup>

        <Reveal className="mt-16 flex flex-col items-start justify-between gap-6 rounded-sm border border-border bg-cream-200 p-8 md:flex-row md:items-center md:p-12">
          <div>
            <h3 className="font-display text-3xl font-medium text-forest md:text-4xl">
              Want the full harvest manifest?
            </h3>
            <p className="mt-2 text-forest-light">
              See every named variety, its region and its months in supply.
            </p>
          </div>
          <Link
            to="/calendar"
            data-testid="products-calendar-btn"
            className="group flex flex-none items-center gap-3 rounded-full bg-forest px-7 py-4 text-cream-100 transition-colors duration-300 hover:bg-forest/90"
          >
            <span className="overline text-cream-100" style={{ fontSize: "0.8rem" }}>Open the sourcing calendar</span>
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </section>
    </>
  );
}
